import styled from "styled-components";
import { mobile } from "../../_themes/constants";

export const Wrapper = styled.div`
  display: inherit;
  flex: 0 0 3em;
  align-items: stretch;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  @media (orientation: landscape) {
    flex: 0 0 ${mobile.landscape.sidePanel.width};
    flex-direction: column;
  }

  @media (orientation: portrait) {
    flex-direction: row-reverse;
  }
`;
